import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, combineLatest, from, map, of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
/**
 * The Service to get/set the current Mandant
 */
@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  /**
   * The Current Mandant Object
   */
  private currentEnv = {
    url: (environment.apiURL == 'null') ? '' : environment.apiURL,
    clientId: (environment.clientID == null) ? '' : environment.clientID,
    color: '#ff00ff'
  }
  /**
   * constructor
   * @param router 
   */
  constructor(private router: Router) {

  }
  /**
   * Set the current ClientConfig
   * @param config 
   */
  public setClientConfig(config): Observable<any> {
    if (config != null) {
      this.currentEnv = {
        url: environment.apiURL,
        clientId: config.id,
        color: '#ff00ff'
      }
      localStorage.setItem('config', JSON.stringify(config));
      return of(JSON.stringify(config))
    } else {
      localStorage.removeItem('currentUser');
      localStorage.removeItem('config');
      this.router.navigate(['login']);
      return of(null)

    }
  }
  /**
   * Get The API V1
   */
  get apiV1$(): Observable<string> {
    if (environment.apiURL != '' && environment.apiURL != 'null' && environment.apiURL != null) {
      return of(`${environment.apiURL}/api/v1/client/${environment.clientID}`);
    } else {
      return of(localStorage.getItem('config')).pipe(
        map(configuration => {
          let env = JSON.parse(configuration);
          return `${env.backend}/api/v1/client/${env.id}`;
        }))
    }
  }
  /**
   * Get The API V2
   */
  get apiV2$(): Observable<string> {
    if (environment.apiURL != '' && environment.apiURL != 'null' && environment.apiURL != null) {
      return of(`${environment.apiURL}/api/v2/client/${environment.clientID}`);
    } else {
      return of(localStorage.getItem('config')).pipe(
        map(configuration => {
          let env = JSON.parse(configuration);
          return `${env.backend}/api/v2/client/${env.id}`;
        }))
    }
  }
  /**
   * Get the API V1 URL
   * @param v 
   * @returns 
   */
  public getApiUrl(v = 'v1') {
    if (environment.apiURL != '' && environment.apiURL != 'null' && environment.apiURL != null) {
      return `${environment.apiURL}/api/${v}/client/${environment.clientID}`;
    } else {
      return of(localStorage.getItem('config')).pipe(
        map(configuration => {
          let env = JSON.parse(configuration);
          return `${env.backend}/api/${v}/client/${env.id}`;
        }))
    }

  }
  /**
   * @deprecated
   * Get the URL for the Client Logo (V1)
   * @param v 
   * @returns 
   */
  public getApiUrlLogoOLD(v = 'v1') {
    if (environment.apiURL != '' && environment.apiURL != 'null' && environment.apiURL != null) {
      return `${environment.apiURL}/api/${v}/client/`;
    } else {
      return of(localStorage.getItem('config')).pipe(
        map(configuration => {
          let env = JSON.parse(configuration);
          return `${env.backend}/api/${v}/client/}`;
        }))
    }
  }
  /**
   * Get the URL for the Client Logo (Dynamic)
   * @param v 
   * @returns 
   */
  public getApiUrlLogo(v = 'v1') {
    if (environment.apiURL != '' && environment.apiURL != 'null' && environment.apiURL != null) {
      return `${environment.apiURL}/${environment.clientID}/dynamic/`;
    } else {
      return `${this.currentEnv.url}/${this.currentEnv.clientId}/dynamic/`;
    }   
  }
  /**
   * @deprecated
   * @param v 
   * @returns 
   */
  public getApiUrlWithV(v) {
    if (environment.apiURL != '' && environment.apiURL != 'null' && environment.apiURL != null) {
      return `${environment.apiURL}/api/${v}/client/${environment.clientID}`;
    } else {
      return of(localStorage.getItem('config')).pipe(
        map(configuration => {
          let env = JSON.parse(configuration);
          return `${env.backend}/api/${v}/client/${env.id}`;
        }))
    }
  }
  /**
   * Get the Plain URL with Version
   * @param v 
   * @returns 
   */
  public getApiPlain(v = 'v1') {
    return `${this.currentEnv.url}/api/${v}/client`;
  }
  /**
   * Get the Current ClientID
   * @returns 
   */
  public getClientId() {
    if (environment.clientID) {
      return environment.clientID;
    } else {
      return this.currentEnv.clientId;
    }

  }
  /**
   * Get the current URL
   * @returns 
   */
  public getUrl() {
    return this.currentEnv.url;
  }
}
